var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBankActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16C23.3284 16 24 15.3284 24 14.5C24 13.6716 23.3284 13 22.5 13C21.6716 13 21 13.6716 21 14.5C21 15.3284 21.6716 16 22.5 16Z",
    fill: "#A68AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9H19",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 5H18",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18C1 17.2044 1.31607 16.4413 1.87868 15.8787C2.44129 15.3161 3.20435 15 4 15",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5425 12H28C28.5304 12 29.0391 12.2107 29.4142 12.5858C29.7893 12.9609 30 13.4696 30 14V18C30 18.5304 29.7893 19.0391 29.4142 19.4142C29.0391 19.7893 28.5304 20 28 20H27L24.7375 26.3363C24.6681 26.5306 24.5403 26.6988 24.3715 26.8176C24.2028 26.9364 24.0014 27.0002 23.795 27H22.205C21.9986 27.0002 21.7972 26.9364 21.6285 26.8176C21.4597 26.6988 21.3319 26.5306 21.2625 26.3363L20.7863 25H12.2138L11.7375 26.3363C11.6681 26.5306 11.5403 26.6988 11.3715 26.8176C11.2028 26.9364 11.0014 27.0002 10.795 27H9.20501C8.99862 27.0002 8.79723 26.9364 8.62849 26.8176C8.45975 26.6988 8.3319 26.5306 8.26251 26.3363L6.62501 21.75C4.93419 19.909 3.99722 17.4996 4.00001 15C4.00001 12.3478 5.05357 9.8043 6.92894 7.92893C8.8043 6.05357 11.3478 5 14 5H18C19.9514 4.99944 21.8603 5.56981 23.4915 6.64083C25.1226 7.71185 26.4048 9.23671 27.18 11.0275C27.3171 11.3454 27.4381 11.6699 27.5425 12Z",
    stroke: "#A68AFF",
    color: "#00000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankActive);
export default __webpack_public_path__ + "static/media/PiggyBankActive.51271a96bdfb10e02e8f8a3d48bb880f.svg";
export { ForwardRef as ReactComponent };